import { Bridge } from '@mc/mc-jsbridge'

export const getBaseInfo = () => {
  if (Bridge.prepared) {
    const { ret, data } = Bridge.call('getBaseInfo')
    if (ret && data) {
      return data
    } else {
      return {}
    }
  } else {
    return {}
  }
}
